import { Component, Input, OnInit, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';

import { Keys, StorageService } from '../../../../../../service/storage.service';
import { ProductService } from '../../../../../../service/finzy-flex/product/product.service';
import { DASHBOARD_LENDER_ATTRIBUTES, LenderProductCategoryVariant } from '../../../../../../model/finzy-flex/lender-account.model';
import { InterestRateRiskRangePopupComponent } from '../../../../../../shared/interest-rate-risk-range-popup/interest-rate-risk-range-popup.component';

@Component({
    selector: 'app-expanded-product-category',
    templateUrl: './expanded-product-category.component.html',
    styleUrls: ['./expanded-product-category.component.scss']
})
export class ExpandedProductCategoryComponent implements OnInit {
    @Input() selectedProduct: string;
    @Input() selectedProductVariant: LenderProductCategoryVariant;
    @Output() isCloseSubProductVariant = new EventEmitter();
    @Input() expansionFor: string;

    public selectedProductVariantToShow: Array<SelectedProductVariantToShow>;
    public isLoading: boolean = false;
    public isShowPercentage: boolean = false;

    constructor(
        private readonly matDialog: MatDialog,
        private readonly storageService: StorageService,
        private readonly productService: ProductService
    ) { }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.selectedProductVariant = changes?.selectedProductVariant?.currentValue;
        const expansionFor = changes.expansionFor ? this.manageProductHeading(changes?.expansionFor?.currentValue) : null ;
        this.transformProductVariantCategory();
    }

    public handleCloseProductVariant(): void {
        this.isCloseSubProductVariant.emit('true')
    }

    public async knowMoreHandler(): Promise<void> {
        this.isLoading = true;
        const lenderId: string = this.storageService.getItem(Keys.LENDER_ID);
        try {
            const riskScore = await this.productService.getRiskScore(lenderId);
            this.isLoading = false;
            const matDialogConfig: MatDialogConfig = {
                maxHeight: '90vh',
                maxWidth: '92vw',
                panelClass: "interest-rate-risk-range",
                data: {
                    buttonText: 'CLOSE',
                    riskScore: {...riskScore},
                    selectedProduct: this.selectedProduct
                }
            };
            this.matDialog.open(InterestRateRiskRangePopupComponent, matDialogConfig).afterClosed();
        } catch (e) {
            console.log(e)
        }
    }

    private manageProductHeading(expansionFor: string) {
        if(expansionFor) {
            switch (expansionFor) {
                case DASHBOARD_LENDER_ATTRIBUTES.EXPANDED_ROI:
                    this.isShowPercentage = true;
                    break;
                default:
                    this.isShowPercentage = false;
                    break;
            }
        }
    }

    private transformProductVariantCategory() {
        this.selectedProductVariantToShow = [];
        for (const key in this.selectedProductVariant) {
            const [product, category] = key.split('_');
            const value = this.selectedProductVariant[key];
            this.selectedProductVariantToShow.push({ product, value, category: category ? category.toUpperCase() : null });
        }
        if(this.selectedProductVariantToShow.length) {
            this.sortSelectedProductVariant(this.selectedProductVariantToShow);
        }
    }

    private sortSelectedProductVariant(selectedProductVariantToShow: Array<SelectedProductVariantToShow>): void {
        selectedProductVariantToShow.sort((a, b) => {
            // If category is null, it comes first
            if (a.category === null && b.category !== null) {
                return -1;
            } else if (a.category !== null && b.category === null) {
                return 1;
            }
        
            // Sort by category first
            if (a.category < b.category) return -1;
            if (a.category > b.category) return 1;
        
            // Then by value
            return a.value - b.value;
        });
    }

}

interface SelectedProductVariantToShow {
    product: string,
    value: number,
    category: string | null,
}
